<script setup lang="ts">
// ================================
// L'explication longue d'une aide du cadre (DEV-2284, lot E repris).
//
// Ce que le courtier doit vivre : l'aide tient en une ligne courte ; le reste
// se lit d'un geste, à la souris, au toucher ou au clavier. L'attribut
// `title` seul ne s'affiche ni au toucher ni au clavier : l'icône est donc un
// bouton qui déplie le texte sous l'aide, et le `title` reste pour le survol.
// ================================
import { ref } from "vue"

const props = defineProps<{ texte: string; testid: string }>()

const ouvert = ref(false)
</script>

<template>
    <button
        type="button"
        class="pi pi-info-circle ml-1 cursor-help align-middle text-xs text-primary-400 hover:text-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-400"
        :title="props.texte"
        :aria-label="props.texte"
        :aria-expanded="ouvert"
        :data-testid="props.testid"
        @click.stop.prevent="ouvert = !ouvert"
    />
    <span
        v-if="ouvert"
        class="mt-0.5 block text-xs text-primary-600"
        data-testid="optim-turpe-v2-info-texte"
        >{{ props.texte }}</span
    >
</template>
